import { reducer as clientReducer } from './clients.slice';

export default clientReducer;
